import { Component, computed, inject, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { IMenuGroup } from '@models/MenuGroup';
import { NavigationService } from '@services/navigation.service';
import { SideNavService } from '@services/side-nav.service';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-side-nav',
    imports: [RouterModule],
    templateUrl: './side-nav.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './side-nav.component.scss'
})
export class SideNavComponent {
    private readonly iconSanitizer: IconSanitizerService = inject(IconSanitizerService);
    private readonly navigationService: NavigationService = inject(NavigationService);
    sideNavService = inject(SideNavService);

    currentUrl = input<string>();
    source: Signal<IMenuGroup[]> = this.navigationService.menu;
    mainGroups = computed(() => this.source().filter((group) => group.isVisible && !group.isFooter));
    footerGroups = computed(() => this.source().filter((group) => group.isVisible && !!group.isFooter));
    logoExpanded: SafeHtml = this.iconSanitizer.getIcon('div25whiteHorizontal');
    logoCollapsed: SafeHtml = this.iconSanitizer.getIcon('div25whiteVertical');
    toggleBackground: SafeHtml = this.iconSanitizer.getIcon('toggleBackground');
    toggleChevronLeft: SafeHtml = this.iconSanitizer.getIcon('toggleChevronLeft');
    toggleChevronRight: SafeHtml = this.iconSanitizer.getIcon('toggleChevronRight');

    isActive(link?: string): boolean {
        return !!link && !!this.currentUrl()?.includes(link);
    }
}
